import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useAppSelector } from '../../hooks/index';
import { Toast, ToastBody, ToastHeader, Table, Row, Col, Input, Label, Button, CardBody, FormFeedback, CardTitle, Card } from 'reactstrap';
import { Afr, getSelectedAfr, getEventList, EventGeneric, pullEventList } from '../../redux/AfrSlice';
import dateHelper from '../../utils/dateHelper';
import utilityHelper from '../../utils/utilityHelper';


const EventList = function (props:
    {
        types: string,  /* This is a list of event types delimited by comma */
        eventsToShow: Array<EventGeneric> | null,
        title : string | null
    }) {

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrEvents: Array<EventGeneric> = useAppSelector(pullEventList);

    var events: Array<EventGeneric> = props.eventsToShow ? props.eventsToShow : [];

    const [eventList, setEventList] = useState(events);
    const componentTitle = props.title ? props.title : "Events";


    useEffect(function () {
        if (props.eventsToShow) {
            setEventList(props.eventsToShow);
        } else {

            var events: Array<EventGeneric> = afrEvents;
            var eventFiltered: Array<EventGeneric> = [];

            if (!(typeof props.types === "undefined") && props.types != "") {

                var filters = props.types.split(",");
                for (var i in filters) {
                    for (var filter_i of afrEvents.filter(x => x.type === filters[i])) {
                        eventFiltered.push(filter_i);
                    }
                }

                events.splice(0, events.length)
                events.push(...eventFiltered);
            }
            setEventList(events);
        }

    }, [afrEvents, currentAfr]);


    return (
        <div>
            <Row>
                <Col md="10">
                    <Toast className="auditDetail">
                        <ToastHeader className="auditDetail">{componentTitle}</ToastHeader>
                        <ToastBody>
                            <div className="scrollable-table">
                            <Table className="table" >
                                    <thead className="scrollable-table-header thead-dark">
                                    <tr>
                                            <th>User</th>
                                            <th>Type</th>
                                            <th>Date</th>
                                            <th>Event Detail</th>
                                    </tr>
                                </thead>

                                <tbody>
                                        {eventList.map((option, idx) => (
                                        <tr key={utilityHelper.generateGuid()}>
                                            <td>{option.user}</td>
                                            <td>{option.type}</td>
                                            <td>{dateHelper.stringDateInFormat(option.date.indexOf("-04:00") > 0 ? option.date.repeat(1).replace("-04:00", "") : option.date, "LL/dd/yyyy")}</td>
                                            <td>{option.detail}</td>
                                        </tr>
                                    ))}

                                </tbody>
                            </Table>
                            </div> 
                        </ToastBody>

                    </Toast>
                </Col>

            </Row>

        </div>
    )

}

export default EventList;